/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

const PrivacyPolicy = () => {

  return (
    <React.Fragment>
      <section className="bg-half bg-light min-vh-100">
        <Container>
          <h3 className="title mb-5 fw-bold text-center">
            Privacybeleid
          </h3>
          <h5 className="title mb-1 fw-bold">
            Inleiding
          </h5>
          <p className="text-muted" >
            Bij werkenindezwembranche.nl hechten wij veel waarde aan de bescherming van uw privacy. Dit privacybeleid beschrijft hoe wij omgaan met uw persoonlijke gegevens wanneer u gebruik maakt van onze diensten.
          </p>
          <h5 className="title mb-1 fw-bold">
            Verzameling van Gegevens
          </h5>
          <ol className="text-muted" >
            <li>
              <strong className="text-dark" >Persoonlijke Gegevens: </strong> Wij verzamelen persoonlijke gegevens zoals naam, e-mailadres, telefoonnummer, en cv wanneer u zich registreert op ons platform of solliciteert op een vacature.
            </li>
            <li>
              <strong className="text-dark" >Automatisch Verzamelde Gegevens:</strong>  Wij verzamelen automatisch gegevens zoals IP-adressen, browser type, en bezochte pagina’s om de gebruikservaring te verbeteren.
            </li>
          </ol>
          <h5 className="title mb-1 fw-bold">
            Gebruik van Gegevens
          </h5>
          <ol className="text-muted" >
            <li>
              <strong className="text-dark" >  Doeleinden: </strong> Uw gegevens worden gebruikt voor het aanbieden van onze diensten, zoals het plaatsen van vacatures, het faciliteren van sollicitaties, en het verzenden van communicatie omtrent uw account en sollicitaties. <br />
            </li>
            <li>
              <strong className="text-dark" >  Marketing:</strong> Wij kunnen uw gegevens gebruiken om u te informeren over onze diensten en aanbiedingen, mits u hiervoor toestemming hebt gegeven.
            </li>
          </ol>

          <h5 className="title mb-1 fw-bold">
            Delen van Gegevens
          </h5>
          <ol className="text-muted" >
            <li><strong className="text-dark" >  Met Werkgevers:</strong> Uw gegevens worden gedeeld met potentiële werkgevers wanneer u solliciteert op een vacature.</li>
            <li>
              <strong className="text-dark" >  Derden:</strong> Wij delen uw gegevens niet met derden zonder uw toestemming, behalve waar dit wettelijk vereist is.
            </li>
          </ol>
          <h5 className="title mb-1 fw-bold">
            Bescherming van Gegevens
          </h5>
          <p className="text-muted" >
            Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen verlies, misbruik, en ongeautoriseerde toegang.
          </p>
          <h5 className="title mb-1 fw-bold">
            Cookies en Tracking
          </h5>
          <ol className="text-muted" >
            <li>
              <strong className="text-dark" > Gebruik van Cookies: </strong> Wij maken gebruik van cookies om onze website te verbeteren en de gebruikerservaring te optimaliseren. Bij uw eerste bezoek vragen wij toestemming voor het gebruik van cookies. <br />
            </li>
            <li>
              <strong className="text-dark" >Afmelden voor Cookies: </strong> U kunt cookies uitschakelen via de instellingen van uw browser, maar dit kan de functionaliteit van onze website beïnvloeden.
            </li>
          </ol>
          <h5 className="title mb-1 fw-bold">
            Uw Rechten
          </h5>
          <ol className="text-muted" >
            <li>
              <strong className="text-dark" >Toegang en Correctie: </strong>   U heeft het recht om uw persoonsgegevens in te zien, te corrigeren, of te verwijderen. Verzoeken kunnen worden ingediend via info@werkenindezwembranche.nl. <br />
            </li>
            <li>
              <strong className="text-dark" >Bezwaar maken: </strong> U heeft het recht om bezwaar te maken tegen de verwerking van uw gegevens voor direct marketing doeleinden.
            </li>
          </ol>
          <h5 className="title mb-1 fw-bold">
            Wijzigingen in het Privacybeleid
          </h5>
          <p className="text-muted" >
            Wij behouden ons het recht voor om dit privacybeleid op elk moment te wijzigen. Wij raden u aan om regelmatig ons privacybeleid te raadplegen voor updates. Substantiële wijzigingen zullen wij communiceren via onze website.
            Contactgegevens
          </p>

          <p className="text-muted" >
            Voor vragen over ons privacybeleid kunt u contact opnemen via: <br />
            <strong className="text-dark" >
              <Link to={'https://werkenindezwembadbranche.nl'} >werkenindezwembranche.nl</Link></strong> <br />
            <strong className="text-dark" > E-mail: <Link to={'mailTo:info@werkenindezwembranche.nl'} >info@werkenindezwembranche.nl</Link> </strong>
          </p>
        </Container>
      </section>
    </React.Fragment>
  );
}
export default PrivacyPolicy
